import { useState } from 'react';
import { RelatedApps, RELATED_BY_APP } from '@hypneuronerd/ui';
import type { Quality } from '../data/qualities';
import { formatDayLong } from '../lib/dates';
import styles from './HeldWord.module.css';

interface HeldWordProps {
  quality: Quality;
  dateStr: string;
}

export function HeldWord({ quality, dateStr }: HeldWordProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <section className={styles.frame}>
      <span className={styles.ornamentTopLeft} aria-hidden="true">
        ❦
      </span>
      <span className={styles.ornamentTopRight} aria-hidden="true">
        ❦
      </span>

      <p className={styles.date}>{formatDayLong(dateStr)}</p>

      <h1 className={styles.word}>{quality.word}</h1>

      <p className={styles.reflection}>{quality.reflection}</p>

      <button
        type="button"
        className={styles.practiceToggle}
        onClick={() => setExpanded((v) => !v)}
        aria-expanded={expanded}
      >
        {expanded ? '— close' : 'throughout today'}
      </button>

      {expanded && (
        <ul className={styles.practices}>
          {quality.practices.map((p, i) => (
            <li key={i}>{p}</li>
          ))}
        </ul>
      )}

      <span className={styles.ornamentBottom} aria-hidden="true">
        ✦
      </span>

      <RelatedApps apps={RELATED_BY_APP['daily-word']} surface="midnight" />
    </section>
  );
}
